export default "/static/explore/52637a98b6af851089caccbad8aa8eb115d3d065/_next/static/images/phone-cfce53e5193bf6ac351cc9ee7a560f31.png";